import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Empty } from "@/components/kit";
import { FEATURE_LABELS } from "@/lib/seo";

export const UpgradeGate = ({ feature, setTab }) => (
  <div data-testid={`upgrade-gate-${feature}`}>
    <Empty icon={Lock} title="Upgrade to unlock" text={`${FEATURE_LABELS[feature]} isn't included in your current plan.`}>
      <Button className="rounded-full font-bold" onClick={() => setTab("billing")} data-testid="upgrade-gate-btn">See plans</Button>
    </Empty>
  </div>
);
